import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface PermissionDefinition {
  name: string
  capabilities: string[]
}

interface Props {
  permission_definitions: PermissionDefinition[]
  groups: PermissionDefinition[]
  notifications: PermissionDefinition[]
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Employees", href: "/employees" },
  {
    title: "Permission Definitions",
    href: "/employees/permission_definitions",
  },
]

function DefinitionList({ items }: { items: PermissionDefinition[] }) {
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <div key={item.name}>
          <h3 className="text-sm font-semibold text-gray-900">{item.name}</h3>
          {item.capabilities.length > 0 && (
            <ul className="mt-1 list-disc space-y-0.5 pl-5 text-sm text-gray-600">
              {item.capabilities.map((cap) => (
                <li key={cap}>{cap}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  )
}

export default function PermissionDefinitions({
  permission_definitions,
  groups,
  notifications,
}: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Permission Definitions" />

      <div className="p-6">
        <h1 className="mb-6 text-center text-2xl font-semibold">
          Permission Definitions
        </h1>

        <div className="border-hpi-light-gray rounded-lg border bg-white p-6">
          <DefinitionList items={permission_definitions} />
        </div>

        <hr className="my-6 border-gray-300" />

        <h2 className="mb-4 text-center text-xl font-semibold">Groups</h2>
        <div className="border-hpi-light-gray rounded-lg border bg-white p-6">
          <DefinitionList items={groups} />
        </div>

        <hr className="my-6 border-gray-300" />

        <h2 className="mb-4 text-center text-xl font-semibold">
          Notifications
        </h2>
        <div className="border-hpi-light-gray rounded-lg border bg-white p-6">
          <DefinitionList items={notifications} />
        </div>
      </div>
    </AppLayout>
  )
}
